export default __webpack_public_path__ + "static/media/hello-beautiful-50-background.fbc011c5.jpg";